import { AxiosResponse } from "axios";
import request from "./axios";
import request_test from "./axios_test";

export const getTestSlideData = (params: {
  id: string;
}): Promise<AxiosResponse<string>> => {
  return request_test.get("/demo/getData", {
    params,
  });
};

export const getUploadFileUrl = (params: {
  sourceType: string;
  file: any;
  pptId: string;
}): Promise<AxiosResponse<string>> => {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  const formData = new FormData();
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return request.post("/ppt/uploadFile", formData, config);
};
